export const REPORTS_FEATURES = {
  moduleKey: 'reports',
  features: ['reports.view'],
  featureMeta: {
    'reports.view': {
      name: 'Reports',
      translations: { name: { de: 'Berichte', en: 'Reports', fr: 'Rapports', it: 'Report' } },
    },
  },
  gatedByFlag: true,
} as const;
